<template>
    <div class="carousel">
              <div>
                  <h2>他们说......</h2>
                    <Carousel arrow="never"  autoplay   class="demo-left" >
                        <CarouselItem v-for="(item,index) in CarouselList" :key="index">
                            <div class="demo-carousel-left">
                                <img src="../assets/dou.png" alt="">
                                <p>{{item.content}}</p>
                                <div>
                                    <img src="../assets/logo-c.png" alt="">
                                    <p>{{item.source}}</p>
                                </div>
                            </div>
                        </CarouselItem>
                    </Carousel>
              </div>
                <div>
                    <h2>成功项目</h2>
                    <!-- -->
                  <div class='demo-right'>
                        <Carousel autoplay   arrow="never" >
                        <CarouselItem v-for="(item,index) in CarouselRightList" :key="index">
                            <div class="demo-carousel-right">
                                <p>{{item.title}}</p>
                                <p>￥{{item.money}}</p>
                                <p>项目发包方评价<img src="../assets/zhan.png" /><img src="../assets/zhan.png" /><img src="../assets/zhan.png" /><img src="../assets/zhan.png" /><img src="../assets/zhan.png" /></p>
                                <p>" {{item.comment1}} "</p>
                                 <p>项目接包方评价<img src="../assets/zhan.png" /><img src="../assets/zhan.png" /><img src="../assets/zhan.png" /><img src="../assets/zhan.png" /><img src="../assets/zhan.png" /></p>
                                <p>" {{item.comment2}} "</p>
                                <img src="../assets/wawayu-logo.png" alt="">
                            </div>
                        </CarouselItem>
                    </Carousel>
                  </div>
              </div>

            </div>
</template>
<script>
export default {
    props:{
        CarouselList:{
            type:Array,
            default:[]
        },
        CarouselRightList:{
            type:Array,
            default:[]
        }
    },
    data(){
        return{
          

        }
    }
}
</script>
<style scoped lang="less">
@baseColor:#4B5F79;
   .carousel{
        width: 1000px;
        margin:40px auto;
        display: flex;
        
        >div{
            flex:1;
            width: 500px;
            text-align: left;
            h2{
                color: @baseColor;
                font-size: 28px;
                margin-bottom: 36px;
                font-weight: normal;
                text-align: left;
            }
            .ivu-carousel{
                width:434px;
                  .demo-carousel-left{
                height: 349px;
                 width: 434px;
               >p{
                    color: @baseColor;
                    font-size: 15px;
                    line-height: 40px;
                    width: 434px;
                }
                >div{
                      width: 434px;
                      overflow: hidden;
                      margin-top: 25px;
                      img{
                          float: left;
                      }
                      p{
                          float: right;
                          line-height: 28px;
                      }
                }

            }
            }
            .demo-right{
                padding-left: 65px;
                 height: 349px;
                 border-left: 1px solid #ECECEC;
            }
        }
        >div:nth-child(2){
            h2{
                padding-left: 65px;
            }
            .ivu-carousel{
                width: 500px;
                .demo-carousel-right{
                     height: 349px;
                     position: relative;
                     >img{
                         position: absolute;
                          right: 0px;
                         top: 66px;
                     }
                       p:nth-child(1){
                color: #546D8B;
                font-size: 19px;
            }
            p:nth-child(2){
                color: #F68058;
                font-size:27px;
                margin-top: 10px;
                margin-bottom: 35px;
            }
            p:nth-child(3),p:nth-child(5){
                display: flex;
                color: #556E8B;
                font-size: 14px;
                
                img{
                    width: 13px;
                    height: 13px;
                    margin:3px 2px;
                }
            }
             p:nth-child(4),p:nth-child(6){
                color: @baseColor;
                font-size: 14px;
                margin-top: 10px;
             }
             p:nth-child(5){
                 margin-top:50px;
             }
                     
                }
            }
           
          
        }
    
    }
</style>


// WEBPACK FOOTER //
// src/components/carouselList.vue